<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ this.base.input.id === null ? "NOUVELLE" : "VOIR UNE" }} DEMANDE
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <form>
          <template
            v-if="$store.state.is_client() || $store.state.is_mandataire()"
          >
            <!-- <div class="flex justify-between">
              <div>
                <span>Contrat</span>
                <span class="font-bold">{{ base.input.contract }}</span>
              </div>
              <div>
                <span
                  class="text-primary underline cursor-pointer"
                  @click="popupActive = true"
                  >Changer</span
                >
              </div>
            </div> -->
            <vs-popup
              class="holamundo"
              title="Changer le contract"
              :active.sync="popupActive"
            >
              <p class="mt-5">Contrat <b style="color: #ff6141">*</b></p>
              <v-select
                :reduce="(rep) => rep.id"
                class="w-full"
                label="code_contract"
                v-model="base.input.contract_id"
                :options="base.customers_contracts"
              ></v-select>
              <vs-button class="mt-3" @click="popupActive = false"
                >Valider</vs-button
              >
            </vs-popup>
          </template>
          <template v-else>
            <p class="mt-5">Client <b style="color: #ff6141">*</b></p>
            <v-select
              :reduce="(rep) => rep.id"
              class="w-full"
              label="social_reason"
              v-model="base.input.customer_id"
              :options="base.customers"
            ></v-select>

            <!-- <p v-if="base.input.customer_id" class="mt-5">
              Contrat <b style="color: #ff6141">*</b>
            </p>
            <v-select
              v-if="base.input.customer_id"
              :reduce="(rep) => rep.id"
              class="w-full"
              label="code_contract"
              v-model="base.input.contract_id"
              :options="base.customers_contracts"
            ></v-select> -->
          </template>
          <!-- NAME -->
          <template v-if="!$store.state.is_commercial()">
            <p class="mt-5">Commercial <b style="color: #ff6141">*</b></p>
            <v-select
              :reduce="(rep) => rep.id"
              class="w-full"
              label="name"
              v-model="base.input.commercial_id"
              :options="base.commerciaux"
            ></v-select>
          </template>

          <p class="mt-5">
            Titre de la demande <b style="color: #ff6141">*</b>
          </p>
          <vs-input
            v-on:keydown.enter.prevent="keyEvent($event)"
            v-model="base.input.title"
            class="w-full"
            name="item-name"
          />

          <p class="mt-5">Type de demande <b style="color: #ff6141">*</b></p>
          <v-select
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="base.input.requests_type_id"
            :options="base.categories_requests"
          ></v-select>

          <p v-if="base.input.requests_type_id" class="mt-5">
            Sous-type de demande <b style="color: #ff6141">*</b>
          </p>
          <v-select
            v-if="base.input.requests_type_id"
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="base.input.requests_subtype_id"
            :options="base.sub_categories_requests"
          ></v-select>

          <p class="mt-5">Priorité <b style="color: #ff6141">*</b></p>
          <v-select
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="base.input.priority_id"
            :options="base.priorities"
          ></v-select>

          <!-- <p v-if="base.input.priority_id" class="mt-5">Urgence (Service Now) <b style="color: #ff6141">*</b></p>
          <v-select
            v-if="base.input.priority_id"
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="base.input.urgency_id"
            :options="base.urgencies"
          ></v-select> -->

          <!-- <p v-if="base.input.urgency_id" class="mt-5">Impact (Service Now) <b style="color: #ff6141">*</b></p>
          <v-select
            v-if="base.input.urgency_id"
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="base.input.impact_id"
            :options="base.impacts"
          ></v-select> -->

          <p class="mt-5">Votre demande<b style="color: #ff6141">*</b></p>
          <vs-textarea
            rows="8"
            v-model="base.input.request_content"
            class="w-full"
            name="item-request"
          />

          <div class="upload-img mt-5">
            <input
              type="file"
              class="hidden"
              ref="uploadimgInput"
              @change="updateCurrimg"
              accept="*/*"
            />
            <vs-button @click.prevent="$refs.uploadimgInput.click()"
              >Joindre un fichier</vs-button
            >
          </div>

          <template v-if="base.input.img && base.input.img.length > 0">
            <h5>Fichier joints</h5>
            <div v-for="(img, index) in base.input.img" :key="index">
              <div class="modify-img flex justify-between mt-5">
                <!-- <input type="file" class="hidden" ref="updateimgInput" @change="updateCurrimg" accept="">
                <vs-button class="mr-4" type="border" @click="$refs.updateimgInput.click()">Changer</vs-button> -->
                <!-- <vs-button class="mr-4" type="border">{{ base.input.img_names[index] }}</vs-button> -->
                <div class="mail__attachment">
                  <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
                    <vs-avatar icon="cloud_download" />
                    {{ base.input.img_names[index] }}
                  </vs-chip>
                </div>
                <vs-button
                  type="border"
                  color="danger"
                  @click.prevent="
                    updateCurrimgSupprimer(base.input.img_names[index])
                  "
                  >Supprimer</vs-button
                >
              </div>
            </div>
          </template>
        </form>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Soumettre</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Annuler</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
let base_self;
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    base: {
      type: Object,
      required: true,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
    },
  },
  data() {
    return {
      form: new FormData(),
      popupActive: false,
      order_status_choices: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      var is_valide = true;
      // if (!this.base.input.contract_id || this.base.input.contract_id === "")
      //   is_valide = false;
      if (
        this.$store.state.is_chargerClientele() &&
        (!this.base.input.customer_id || this.base.input.customer_id === "")
      )
        is_valide = false;
      if (!this.base.input.title || this.base.input.title === "")
        is_valide = false;
      if (
        !this.base.input.requests_type_id ||
        this.base.input.requests_type_id === ""
      )
        is_valide = false;
      if (
        !this.base.input.requests_subtype_id ||
        this.base.input.requests_subtype_id === ""
      )
        is_valide = false;
      if (!this.base.input.priority_id || this.base.input.priority_id === "")
        is_valide = false;
      if (
        !this.base.input.request_content ||
        this.base.input.request_content === ""
      )
        is_valide = false;

      if (
        !this.base.input.commercial_id ||
        this.base.input.commercial_id === ""
      ) {
        is_valide = false;
      }

      // if (!this.base.input.urgency_id || this.base.input.urgency_id === "") {
      //   is_valide = false;
      // }

      // if (!this.base.input.impact_id || this.base.input.impact_id === "") {
      //   is_valide = false;
      // }
      return is_valide;
    },
  },
  methods: {
    keyEvent(event) {
      if (event) event.preventDefault();
    },
    initValues() {
      if (this.base.input.id) return;

      this.form = new FormData();
      this.base.input = JSON.parse(JSON.stringify(this.base.input_tempon));
      if (this.$store.state.is_commercial()) {
        this.base.input.commercial_id =
          window.GETCCMT.$store.state.AppActiveUser.id;
      } else if (this.$store.state.is_client()) {
        this.base.input.commercial_id = window.GETCCMT.$store.state
          .AppActiveUser.commercial_id
          ? window.GETCCMT.$store.state.AppActiveUser.commercial_id
          : "";
      }
    },
    async submitData() {
      base_self.$vs.loading();
      var result = await this.$validator.validateAll();

      delete this.base.input.img;
      // delete this.base.input.id;

      var form = new FormData();
      const keys = Object.keys(this.base.input);
      var length = keys ? keys.length : 0;
      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = keys[iuoy];
        form.append(item, this.base.input[item]);
      }

      var lengthk = this.base.input.files ? this.base.input.files.length : 0;
      for (let iuoy = 0; iuoy < lengthk; iuoy++) {
        var item1 = this.base.input.files[iuoy];
        form.append("files[" + iuoy + "]", item1);
      }

      if (result) {
        if (this.base.input.id === null) {
          // console.log('form: ', form);
          let response = await base_self.$store.state
            .requests_create(form)
            .catch((error) => {
              console.log("error: ", error);
            });

          if (response.data.status) {
            window.GETCCMT.success(
              "La demande est envoyée avec succès.",
              response
            );
            window.RequestsApp.getRequests();

            this.$emit("closeSidebar");
            this.initValues();
          } else {
            window.GETCCMT.error({ message: "La demande a échouée." });
          }
        }
      }
      base_self.$vs.loading.close();
    },
    validateAction() {
      if (this.isFormValid) {
        this.submitData();
      } else {
        window.GETCCMT.notification(
          "danger",
          "Erreur",
          "Veuillez remplir les champs obligatoires"
        );
      }
    },
    updateCurrimgSupprimer(img_name) {
      var length = base_self.base.input.img_names
        ? base_self.base.input.img_names.length
        : 0;
      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = base_self.base.input.img_names[iuoy];
        if (img_name === item) {
          base_self.base.input.img_names.splice(iuoy, 1);
          base_self.base.input.img.splice(iuoy, 1);
          base_self.base.input.files.splice(iuoy, 1);
          break;
        }
      }
    },
    updateCurrimg(input) {
      // console.log('input.srcElement.files[0].name: ', input.srcElement.files[0].name);
      // console.log('input: ', input);

      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          // console.log(e.target);
          base_self.base.input.img_names.push(input.srcElement.files[0].name);
          base_self.base.input.img.push(e.target.result);
          this.base.input.files.push(base_self.$refs.uploadimgInput.files[0]);
          // base_self.form.append('files[0]', base_self.$refs.uploadimgInput.files[0]);
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateContract() {}
  },
  components: {
    VuePerfectScrollbar,
  },
  created() {
    base_self = this;
    base_self.initValues();
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
